import { ProgramReadiness, ProgramReadinessField } from './programs.types';

/**
 * Pure derivations from the `ProgramReadiness` snapshot. The Model and View
 * layers reach for these instead of poking the booleans directly, so the
 * "what does ready mean?" rule lives in exactly one place.
 */

export const ALL_READINESS_FIELDS: ReadonlyArray<ProgramReadinessField> = [
  'title',
  'cover',
  'workouts',
  'goal',
];

export const isReady = (readiness: ProgramReadiness): boolean =>
  Object.values(readiness).every((satisfied) => satisfied);

export const unmetFields = (
  readiness: ProgramReadiness,
): ProgramReadinessField[] =>
  ALL_READINESS_FIELDS.filter((field) => !readiness[field]);

export const unmetCount = (readiness: ProgramReadiness): number =>
  unmetFields(readiness).length;

/**
 * Human-readable label for each criterion. Kept here so the badge tooltip
 * (U7), popover list (U8), and dropdown disable tooltip (U9) all use the
 * same wording — and a Figma rewording can update them in one place.
 */
export const FIELD_LABEL: Readonly<Record<ProgramReadinessField, string>> = {
  title: 'Title',
  cover: 'Cover image',
  workouts: 'Published workouts',
  goal: 'Goal',
};

/**
 * Imperative action label per criterion — used by the readiness popover
 * which presents each unmet criterion as a call to action ("Add Title",
 * "Define program goals") rather than the noun form used in the dropdown
 * "Missing: ..." tooltip.
 */
export const ACTION_LABEL: Readonly<Record<ProgramReadinessField, string>> = {
  title: 'Add Title',
  cover: 'Add Cover image',
  workouts: 'Add workouts',
  goal: 'Define program goals',
};

export const metCount = (readiness: ProgramReadiness): number =>
  ALL_READINESS_FIELDS.length - unmetCount(readiness);

export const totalCount = (): number => ALL_READINESS_FIELDS.length;
